import React from 'react';
import MaterialIcon from 'material-icons-react';
import './Loader.css';

export default class Loader extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="canva" name="canva" className="canva">
            {<div className="canvaLoader centralizar"></div>}
          </div>
        );
    }
};

